import styled from "styled-components";

export const StyledContainer = styled.div`
  text-align: left;
  margin: 0 auto;
  @media (min-width: 994px) {
    margin-top: 50px;
  }
`;
